import { Doctor } from "../types/doctor";
import { TimeSlot } from "../types/timeslot";
import { action, makeObservable, observable } from "mobx";

class DoctorsStore {
    @observable selectedAptTypeDoctors: Doctor[] | undefined = undefined;
    @observable selectedAptTypeFirstAvailableTimes: Record<string, TimeSlot> | undefined;
    @observable selectedDoctor: Doctor | undefined = undefined;

    constructor() {
        makeObservable(this)
    }

    @action
    setSelectedAptTypeDoctors = (doctors: Doctor[]) => {
        this.selectedAptTypeDoctors = doctors;
    }

    @action
    setCurrentDoctor = (doctor: Doctor) => {
        this.selectedDoctor = doctor;
    }

    @action
    setSelectedAptTypeFirstAvailableTimes = (firstAvailableTimes: Record<string, TimeSlot>) => {
        this.selectedAptTypeFirstAvailableTimes = firstAvailableTimes;
    }
}

export const doctorsStore = new DoctorsStore();